import { render, staticRenderFns } from "./MoonjellyCard.vue?vue&type=template&id=bff0fee4&scoped=true&"
import script from "./MoonjellyCard.vue?vue&type=script&lang=js&"
export * from "./MoonjellyCard.vue?vue&type=script&lang=js&"
import style0 from "./MoonjellyCard.vue?vue&type=style&index=0&id=bff0fee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff0fee4",
  null
  
)

export default component.exports